import React from 'react';
import classnames from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './tos-checkbox.scss';
const checkboxClasses = {
  root: classes.checkboxRoot
};
export const TosCheckbox = ({
  isChecked,
  isLimitedEdition,
  buttonName,
  onChange,
  isFixedStyling,
  tosCheckboxWrapperClassName = undefined
}) => {
  return /*#__PURE__*/React.createElement("div", {
    onClick: () => onChange(!isChecked),
    className: classnames(classes.tosCheckbox, tosCheckboxWrapperClassName, {
      [classes.fixedStyling]: isFixedStyling
    })
  }, /*#__PURE__*/React.createElement(Checkbox, {
    classes: checkboxClasses,
    checked: isChecked,
    color: "default"
  }), "By clicking \"", buttonName, "\", I agree to the", ' ', /*#__PURE__*/React.createElement("a", {
    className: classnames(classes.link, {
      [classes.orangeColor]: isLimitedEdition
    }),
    onClick: e => e.stopPropagation(),
    rel: "noreferrer",
    target: "_blank",
    href: APP_ROUTES.TOS
  }, "terms of service"), ".");
};